import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';
import './BuildingDocumentsViewer.css';
import PropTypes from 'prop-types';
import DocumentLink from './DocumentLink';

class BuildingDocumentsViewer extends Component {
  static propTypes = {
    documents: PropTypes.arrayOf(PropTypes.any).isRequired,
  };

  render() {
    return (
      <div className="building-documents-viewer">
        <div>INSURANCE & BUILDING REGULATIONS</div>
        <div>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <ul>
          {this.props.documents.map((element) => {
            return (
              <li key={element.id}>
                <DocumentLink url={element.document.url} />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default BuildingDocumentsViewer;



// WEBPACK FOOTER //
// ./src/components/shared/document/BuildingDocumentsViewer.js